import { LinkButton } from '@pmi/dsm-react';
import { ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toastWithAnalytics } from '../../../../../../shared/analytics';
import { toDayMonthYear } from '../../../../../../shared/helpers';
import { accountSelector } from '../../../../../../shared/store/shared/accountSlice';
import { addAdminResend, adminResendList } from '../../../resendActionSlice';
import { useResentAdminInvitationMutation } from '../apiSlice';
import { TableCellProps } from '../models';

function RegisteredCell({ row }: TableCellProps) {
  const { currentAccountId } = useSelector(accountSelector);
  const dispatch = useDispatch();
  const [resentInvitation, resendInvitation] =
    useResentAdminInvitationMutation();
  const isInResendList = useSelector(adminResendList).includes(
    row.original.inviteCode,
  );
  const { acceptedDate: dateRegistered } = row.original;
  const onResendClick = (
    accountId: string,
    inviteId: string,
    email: string,
  ) => {
    resentInvitation({
      accountId,
      inviteId,
    })
      .unwrap()
      .then(() => {
        const message = (): ReactNode => (
          <>
            Invite resent to <span data-exclude-lg="true">{email}</span>
          </>
        );
        toastWithAnalytics(message(), 'success');
        resendInvitation.reset();
      })
      .catch(() => {
        toastWithAnalytics(
          'Could not resend invitation. Please try again.',
          'danger',
        );
      });
  };

  const renderRegisteredDate = () =>
    dateRegistered ? (
      <span>{toDayMonthYear(dateRegistered.toString())}</span>
    ) : (
      <span>30 minutes ago</span>
    );

  const isPending = () => row.original.inviteStatus.toLowerCase() === 'pending';

  return (
    <div
      className="cell d-flex align-items-center"
      key={`registered-${row.original.personId}`}
    >
      {!isPending() ? (
        renderRegisteredDate()
      ) : (
        <span className="d-flex align-items-center">
          <span className="d-block me-1">Pending</span>
          {resendInvitation.isLoading ? (
            <Spinner size="sm" className="text-primary ms-1" />
          ) : (
            <LinkButton
              size="xs"
              titleText="Resend"
              className="resendInvite"
              disabled={resendInvitation.isLoading || isInResendList}
              onClick={
                resendInvitation.isLoading || isInResendList
                  ? () => null
                  : () => {
                      dispatch(addAdminResend(row.original.inviteCode));
                      onResendClick(
                        currentAccountId,
                        row.original.inviteCode,
                        row.original.invitationEmail,
                      );
                    }
              }
            />
          )}
        </span>
      )}
    </div>
  );
}

export default RegisteredCell;
